const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets hoje: ",
          },
          entriesByHour: "Entradas por hora",
          pendingByHour: "Tickets em espera por hora",
          deliveredMessages: {
            title: "Mensagens entregues por dia",
            confirmed: "Entrega confirmada",
            estimated: "Histórico estimado",
            unknownCategory: "Categoria não informada",
            noConnection: "Sem conexão",
            note: "O gráfico é dividido por linha do WhatsApp. O histórico anterior é estimado pela data de envio."
          },
          ticketsLabel: "Entradas",
          pendingLabel: "Em espera"
        },
        metrics: {
          title: "Metricas de tickets",
          exactFrom: "Dados exatos desde a ativacao do rastreamento de status",
          infoClose: "Fechar",
          range: {
            label: "Periodo",
            today: "Hoje",
            yesterday: "Ontem",
            last7Days: "Ultimos 7 dias",
            last30Days: "Ultimos 30 dias",
            last90Days: "Ultimos 90 dias"
          },
          filters: {
            firstResponseTarget: "Meta 1a resposta (min)",
            resolutionTarget: "Meta resolucao (h)"
          },
          firstResponseTime: "Tempo medio para primeiro atendimento",
          firstResponseP50: "Primeiro atendimento P50",
          firstResponseP90: "Primeiro atendimento P90",
          resolutionTime: "Tempo medio para resolucao",
          resolutionP50: "Resolucao P50",
          resolutionP90: "Resolucao P90",
          pendingTime: "Tempo medio em espera",
          pendingP50: "Espera P50",
          pendingP90: "Espera P90",
          openTime: "Tempo medio em atendimento",
          openP50: "Atendimento P50",
          openP90: "Atendimento P90",
          slaFirstResponse: "SLA primeiro atendimento",
          slaResolution: "SLA resolucao",
          peakEntryHour: "Hora pico de entrada",
          peakPendingHour: "Hora pico em espera",
          topResolvers: "Usuarios com mais tickets resolvidos",
          table: {
            user: "Usuario",
            resolved: "Resolvidos",
            avgFirstResponse: "1a resposta media",
            avgResolution: "Resolucao media",
            slaFirstResponse: "SLA 1a resp.",
            slaResolution: "SLA resolucao",
            reopened: "Reaberturas",
            active: "Ativos",
            avgPerTicket: "Tempo medio por ticket",
            noData: "Sem dados para este periodo"
          },
          descriptions: {
            firstResponseTime: "Media do tempo entre a entrada do ticket e o primeiro momento em atendimento.",
            firstResponseP50: "Percentil 50 de primeiro atendimento: metade dos tickets e atendida nesse tempo ou menos.",
            firstResponseP90: "Percentil 90 de primeiro atendimento: 90% dos tickets sao atendidos nesse tempo ou menos.",
            slaFirstResponse: "Percentual de tickets que cumprem a meta configurada para primeiro atendimento.",
            slaResolution: "Percentual de tickets resolvidos dentro da meta de resolucao configurada.",
            peakEntryHour: "Faixa horaria com maior volume de entrada de tickets no periodo selecionado.",
            peakPendingHour: "Faixa horaria com mais tickets em espera no periodo selecionado.",
            resolutionTime: "Media do tempo total entre entrada e fechamento do ticket.",
            resolutionP50: "Percentil 50 de resolucao: metade dos tickets e resolvida nesse tempo ou menos.",
            resolutionP90: "Percentil 90 de resolucao: 90% dos tickets sao resolvidos nesse tempo ou menos.",
            pendingTime: "Media do tempo acumulado que cada ticket fica em espera.",
            pendingP50: "Percentil 50 do tempo em espera por ticket.",
            pendingP90: "Percentil 90 do tempo em espera por ticket.",
            openTime: "Media do tempo acumulado que cada ticket fica em atendimento.",
            openP50: "Percentil 50 do tempo em atendimento por ticket.",
            openP90: "Percentil 90 do tempo em atendimento por ticket.",
            topResolvers: "Ranking de usuarios com mais tickets resolvidos e seus tempos medios associados."
          },
          examples: {
            firstResponseTime: "Exemplo: ticket entra 10:00 e e atendido 10:12 -> primeiro atendimento = 12 min.",
            firstResponseP50: "Exemplo: P50 = 8 min significa que metade dos tickets e atendida em <= 8 min.",
            firstResponseP90: "Exemplo: P90 = 25 min significa que 90% dos tickets sao atendidos em <= 25 min.",
            slaFirstResponse: "Exemplo: meta 15 min e SLA 82% significa que 82 de cada 100 tickets foram atendidos em <= 15 min.",
            slaResolution: "Exemplo: meta 24 h e SLA 76% significa que 76 de cada 100 tickets foram resolvidos em <= 24 h.",
            peakEntryHour: "Exemplo: 11:00 (34) significa 34 tickets de entrada entre 11:00 e 11:59.",
            peakPendingHour: "Exemplo: 15:00 (18) significa 18 tickets distintos em espera nessa faixa.",
            resolutionTime: "Exemplo: ticket entra 09:00 e fecha 13:30 -> resolucao = 4 h 30 min.",
            resolutionP50: "Exemplo: P50 = 2 h significa que metade dos tickets e resolvida em <= 2 h.",
            resolutionP90: "Exemplo: P90 = 14 h significa que 90% e resolvido em <= 14 h.",
            pendingTime: "Exemplo: se um ticket ficou 20 min em espera e depois mais 10 min, total em espera = 30 min.",
            pendingP50: "Exemplo: P50 espera = 12 min significa que metade dos tickets esperou <= 12 min.",
            pendingP90: "Exemplo: P90 espera = 55 min significa que 90% esperou <= 55 min.",
            openTime: "Exemplo: soma de todos os periodos em atendimento de um ticket.",
            openP50: "Exemplo: P50 atendimento = 40 min significa que metade dos tickets ficou em atendimento <= 40 min.",
            openP90: "Exemplo: P90 atendimento = 3 h 10 min significa que 90% ficou em atendimento <= esse tempo.",
            topResolvers: "Exemplo: um usuario com 120 resolvidos e menor tempo medio ficara melhor no ranking."
          }
        },
        messages: {
          inAttendance: {
            title: "Em Atendimento"
          },
          waiting: {
            title: "Aguardando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexões",
        toasts: {
          deleted: "Conexão com o WhatsApp excluída com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar WhatsApp",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        form: {
          name: "Nome",
          default: "Padrão",
          farewellMessage: "Mensagem de despedida"
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "WhatsApp salvo com sucesso.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os tickets relacionados serão perdidos.",
          importMessage: "Deseja importas todos os contatos do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Ações",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      quickAnswersModal: {
        title: {
          add: "Adicionar Resposta Rápida",
          edit: "Editar Resposta Rápida",
        },
        form: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Resposta Rápida salva com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar fila",
          edit: "Editar fila",
        },
        form: {
          name: "Nome",
          color: "Cor",
          greetingMessage: "Mensagem de saudação",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Usuário salvo com sucesso.",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        toasts: {
          deleted: "O ticket que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar tickets e mensagens",
        },
        closedSearch: {
          placeholder: "Buscar por nome ou contato",
        },
        buttons: {
          showMine: "Meus",
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldConnectionLabel: "Transferir para conexão",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldConnectionPlaceholder: "Selecione uma conexão",
        noOptions: "Nenhum usuário encontrado com esse nome",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum ticket encontrado com esse status ou termo pesquisado",
        connectionTitle: "Conexão que está sendo utilizada atualmente.",
        buttons: {
          accept: "Aceitar",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Pesquise um contato ou digite um numero",
        add: "Adicionar",
        addNumber: "Abrir chat com",
        countryCode: "Prefixo",
        connection: "Linha",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          tickets: "Tickets",
          contacts: "Contatos",
          quickAnswers: "Respostas Rápidas",
          appointments: "Agendamentos",
          queues: "Filas",
          administration: "Administração",
          users: "Usuários",
          settings: "Configurações",
          systemChecks: "Verificações",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar fila",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os tickets dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queueSelect: {
        inputLabel: "Filas",
      },
      quickAnswers: {
        title: "Respostas Rápidas",
        table: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Resposta Rápida",
        },
        toasts: {
          deleted: "Resposta Rápida excluída com sucesso.",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle:
            "Você tem certeza que quer excluir esta Resposta Rápida: ",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
      },
      users: {
        title: "Usuários",
        table: {
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          ticketLockByAgent: {
            name: "Bloqueio de atendimento por agente",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
        },
      },
      appointments: {
        title: "Agendamentos",
        openExternal: "Abrir fora",
        loadError: "Nao foi possivel carregar o calendario de agendamentos.",
      },
      appUpdate: {
        message: "Há uma nova versão disponível.",
        warning: "Ao atualizar, sua sessão será encerrada e os dados locais serão limpos.",
        action: "Atualizar agora",
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          buttons: {
            return: "Retornar",
            transfer: "Transferir",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem ou tecle ''/'' para utilizar as respostas rápidas cadastrada",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
        },
        extraInfo: "Outras informações",
      },
      ticketOptionsMenu: {
        delete: "Deletar",
        transfer: "Transferir",
        confirmationModal: {
          title: "Deletar o ticket do contato",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_CITAS_EMBED_API_KEY_NOT_CONFIGURED:
          "A API key interna do embed de agendamentos nao esta configurada.",
        ERR_CITAS_EMBED_TOKEN_REQUEST_FAILED:
          "Nao foi possivel obter o token temporario do calendario de agendamentos.",
        ERR_CITAS_EMBED_TOKEN_RESPONSE_INVALID:
          "A resposta do calendario de agendamentos nao incluiu um token valido.",
      },
    },
  },
};

export { messages };
